<template>
  <div class="list">
    <div class="box-hd">
      <!-- <a href="javascript:void(0);" class="back" @click="back"></a>
      <h3>客服消息</h3> -->
      <a href="javascript:void(0);" class="rt" @click="clear" style="color:#666;">
        清除未读
      </a>
    </div>
    <div class="scroll">
      <div class="ul">
        <router-link  v-slot="{ navigate, href }" v-for="(i,index) in list" :to="{ path: '/index', query: { groupId: i.id,token:useWork().auth.token,wxappId:query.wxappId,code:i.code} }" tag="div">
          <van-swipe-cell>
              <div class="li" @click="went(i.id,index)">
                <img :src="i.groupHeadImage || require('@/assets/images/aqghand.png')" />
                <div class="rt">
                  <div class="tp">
                    <div class="name">{{i.groupName}}</div>
                    <div class="time">{{Ftime(i.showTime)}}</div>
                  </div>
                  <div class="bot">
                    <div class="say" v-html="processedContent(i.lastContent)"></div>
                    <div class="nums" v-if="i.offlineCount>0">{{i.offlineCount>99?'99+':i.offlineCount}}</div>
                  </div>
                </div>
              </div>
              <template #right>
                <a href="javascript:void(0);"  class="delete-button" @click='del(i.id)'>删除</a>
              </template>
          </van-swipe-cell>
        </router-link>
      </div>
      <div class="nobg" v-if="list.length==0 && isload">
        <div class="thtit">你还没有任何消息</div>
      </div>
    </div>
  </div>
</template>
<script setup>
  import {ref,onMounted, reactive,computed} from 'vue';
  import { useSocket} from "@/stores/index";
  const store = useSocket();
  const list = computed(() => store.groupList)
  import { useRouter } from 'vue-router';
  import { showConfirmDialog ,showToast  } from 'vant';
  import { delGroup } from '@/api/index';
  const router = useRouter();
  import wx from "weixin-js-sdk";
  import { useWork } from "@/stores/work";
  const query = reactive(router.currentRoute.value.query)
  const isload=ref(false)
  const href= ref('')
  const Ftime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const isToday = date.toDateString() === now.toDateString();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    if (isToday) {
      return `${hours}:${minutes}:${seconds}`;
    } else {
      return `${year}-${month}-${day}`;
    }
  };
  const back = () => {
    wx.miniProgram.navigateBack({
      delta: 1
    })
  };
  const processedContent=(val)=>{
    if(val){
      return val.replace(/&amp;/g, '&')
    }else{
      return ''
    }
  };
  const clear = () => {
    store.clearNoRead()
  }
  const went=(id,index)=>{
    store.clearNoRead(id,index)
  }
  const del = (groupId) => {
    showConfirmDialog({
      title: '提示',
      message:'确定删除该聊天吗？',
    }).then(() => {
      delGroup({groupId:groupId,wxappId:useWork().auth.wxappId}).then(e=>{
          showToast('删除成功'); 
          store.getGroupInit()
      })
    })
    .catch(() => {
      // on cancel
    });
  }
  onMounted(async() => {
     href.value=window.location
    if(query.groupId){
      router.replace({
        path: '/index',
        query: {
          groupId: query.groupId,
          token: query.token,
          wxappId: query.wxappId,
          code: query.code  
        }
      })
    }
    else{
        href.value=window.location
        try {
          await store.getGroupInit()
          isload.value=true;
          setTimeout(() => {
            window.document.title = '在线客服'
          }, 500);
          
        } catch (err) {
          console.log(err)
        }
    }
  
  })
</script>
<style lang="scss">
  .delete-button{
      background: #f00;
      display: flex;
      height: 100%;
      padding: 0 14px;
      justify-content: center;
      align-items: center;
      color:#fff;
  }
</style>
<style lang="scss" scoped>
  .nobg{
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .thtit{
      background: url('../assets/images/nobg.png') no-repeat center top;
      background-size: 81px auto;
      font-weight: 400;
      font-size: 15px;
      color: #333;
      text-align: center;
      padding-top:86px;
    }
  }
  .list {
    background: #F6F6F6;
    height: 100vh;
    overflow: hidden;
    .scroll {
      padding: 10px;
      box-sizing: border-box;
      height: calc(100vh - 48px);
      .ul {
        overflow: hidden;
        border-radius: 10px;
      }
      .li {
        
        padding: 14px 12px 0;
        background: #fff;
        display: flex;
        &:nth-last-child(2){
          .rt {
            border-bottom: 0;
          }
        }
        img {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          margin-right: 14px;
        }
        .rt {
          padding-bottom: 12px;
          flex: 3;
          max-width: calc(100% - 60px);
          border-bottom: 1px solid #E9E9E9;
          .tp {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 6px;
            height: 22px;
            font-weight: 400;
            .name {
              font-size: 16px;
              color: #1F1F1F;
            }
            .time {
              font-size: 12px;
              color: #BCBCBC;
            }
          }
          .bot {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .say {
              max-width: 80%;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              font-weight: 400;
              font-size: 13px;
              color: #9B9B9B;
              line-height: 18px;
              min-height: 36px;
            }
            .nums {
              width: 16px;
              height: 16px;
              background: #DC4740;
              border-radius: 50%;
              font-size: 8px;
              color: #fff;
              display: flex;
              align-items: center;
              justify-content: center;
            }
          }
        }
      }
    }
  }
</style>